/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';

axios.defaults.timeout = 5000;
axios.defaults.timeoutErrorMessage =
  'Долгое ожидание ответа сервера. Проверьте соединение или попробуйте позже.';

export const $host = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
});

export const $oldHost = axios.create({
  baseURL: 'https://schedule-bot.kai.ru/api/',
});

export const $authHost = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
});
